let routePlannerModule: Promise<typeof import("../routePlanner")> | undefined;

export const loadRoutePlanner = () => {
  routePlannerModule ??= import("../routePlanner");
  return routePlannerModule;
};

export const preloadRoutePlanner = () => {
  void loadRoutePlanner();
};
